import { render } from "./HomeComponent.vue?vue&type=template&id=0163108a&ts=true"
import script from "./HomeComponent.ts?vue&type=script&lang=ts&external"
export * from "./HomeComponent.ts?vue&type=script&lang=ts&external"

import "./HomeComponent.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__